import { FormHelperText as MFormHelperText, FormHelperTextProps } from '@mui/material'

export const FormHelperText: React.FC<FormHelperTextProps> = (props) => {
  return <MFormHelperText {...props} />
}
